import React from "react";
import { Row, Col } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import { HookFormRadioButton } from "components";
import { TerminalSolutionOrigin } from "types/enums";

import styles from "../terminalSolution.module.scss";

type OriginProps = {
	isLoading?: boolean;
};

const Origin = ({ isLoading = false }: OriginProps) => {
	const { register } = useFormContext();

	return (
		<div className={styles.section} data-autotest="originSection">
			<p>Origin</p>
			<Row>
				<Col md={2}>
					<HookFormRadioButton
						id="applicationOrigin"
						register={register}
						name="origin"
						value={TerminalSolutionOrigin.Application.name}
						label="Application"
						blurLoading={isLoading}
					/>
				</Col>
				<Col md={4}>
					<HookFormRadioButton
						id="existingMerchantOrigin"
						register={register}
						value={TerminalSolutionOrigin.Merchant.name}
						name="origin"
						label="Existing Merchant Request"
						blurLoading={isLoading}
					/>
				</Col>
			</Row>
		</div>
	);
};

export default Origin;
